import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { taxonomyLookupModalReducerKey } from './TaxonomyLookupModalConstants';
import {
  isLoading as isLoadingSelector,
  opModel as opModelSelector,
  search as searchSelector,
  selectedItems as selectedItemsSelector,
  boundOperator as boundOperatorSelector,
  totalHitCount as totalHitCountSelector,
  transferEnabled as transferEnabledSelector,
} from './TaxonomyLookupModalSelectors';

import {
  applyChanges,
  clearSelected,
  init,
  closeTaxonomyLookupModal,
  getTreeView,
  setIsLoading,
  showEmptyResult,
  searchByKeyword,
  setBoundOperator,
  applyResultsFromTreeView,
  initTreeView,
  resetTreeView,
  getSuggestions,
} from './TaxonomyLookupModalActions';
import taxonomyLookupModalReducer from './TaxonomyLookupModalReducer';
import TaxonomyLookupModal from './TaxonomyLookupModal';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  opModel: opModelSelector(state),
  search: searchSelector(state),
  boundOperator: boundOperatorSelector(state),
  selectedItems: selectedItemsSelector(state),
  totalHitCount: totalHitCountSelector(state),
  transferEnabled: transferEnabledSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init(ownProps)),
  initTreeView: (handlers) => initTreeView(handlers),
  resetTreeView: (handlers) => resetTreeView(handlers),
  selectBoundOperator: (operator) => dispatch(setBoundOperator(operator)),
  close: () => dispatch(closeTaxonomyLookupModal()),
  clearSelected: () => dispatch(clearSelected()),
  getSuggestions: (keyword) => dispatch(getSuggestions(keyword)),
  applyChanges: () => dispatch(applyChanges(ownProps.closeCallback)),
  searchByKeyword: (keyword) => dispatch(searchByKeyword(keyword)),
  showEmptyResult: () => dispatch(showEmptyResult()),
  startLoading: () => dispatch(setIsLoading(true)),
  stopLoading: () => dispatch(setIsLoading(false)),
  applyResultsFromTreeView: (selectedTaxonomies, selectedCustom, totalHitCount) =>
    dispatch(applyResultsFromTreeView(selectedTaxonomies, selectedCustom, totalHitCount)),
  getTreeView: (params) => dispatch(getTreeView(params, ownProps.suggestInit)),
});

export default compose(
  withReducer(taxonomyLookupModalReducerKey, taxonomyLookupModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(TaxonomyLookupModal);
